export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    // Accordion Component
    const accordionButtons = document.querySelectorAll('.accordion');
    const plusButton = document.querySelector('.js-plus-sign');
    const minusButton = document.querySelector('.js-minus-sign');

    const accordionAction = ({ currentTarget: accordion }) => {
      /**
       * @var {Element} accordionContent
       */
      const accordionContent = accordion.querySelector('.accordion-inner-container');
      accordionContent.classList.toggle('accordion-inner-open');

      accordion.querySelector('img').src = 
      accordion.querySelector('img').src === plusButton.src ?
          minusButton.src : plusButton.src;
    }

    accordionButtons.forEach((accordionButton) => {
      accordionButton.addEventListener('click', accordionAction, false);
    });

    // Back to top
    const backToTopButton = document.querySelectorAll('.js-back-to-top');

    const backToTopHandler = (e) => {
      e.preventDefault();

      window.scrollTo(0, 0);
    }

    backToTopButton.forEach((button) => {
      button.addEventListener('click', backToTopHandler);
    });

    // Mobile Navigation
    const hamburgerButton = document.querySelector('.js-hamburger-button');
    const hamburgerClose = document.querySelector('.js-mobile-nav-close');
    const mobileNavCon = document.querySelector('.js-mobile-nav');
    const header = document.querySelector('#atf-main-header');

    mobileNavCon.style.top = `${header.offsetHeight + document.body.parentElement.offsetTop}px`;

    const mobileNavHandler = (e) => {
      e.preventDefault();

      mobileNavCon.classList.toggle('mobile-nav-con-disabled');
      document.body.classList.toggle('mobile-menu-active');
    }

    hamburgerButton.addEventListener('click', mobileNavHandler);
    hamburgerClose.addEventListener('click', mobileNavHandler);

    // Footer Nav Jumps
    const areaId = window.location.href.split('#')[1];
    const areaSelected = document.getElementById(areaId);

    if (areaId !== undefined && areaSelected !== null) {
      areaSelected.scrollIntoView();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js